import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import Typography from '../../components/common/Typography';
import Button from '../../components/common/Button';
import { FindPasswordButton } from '../../components/common/FullButton';
import { HtmInfoSend, HtmKakaoSend } from './findByPasswordSlice';
import { formatPhoneNumber } from '../../common/Util';

const Step3 = ({ stepHandler }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('findPassword');
  const { t: tCommon } = useTranslation('common');
  const { idInfo } = useSelector(state => state.findByPassword);

  const clickSms = () => {
    dispatch(HtmInfoSend({ htmMCd: idInfo.htmMCd, htmSCd: idInfo.htmSCd, cmd: 'HtmHTelSend' }));
  };

  const clickAlimtalk = () => {
    dispatch(HtmKakaoSend({ htmMCd: idInfo.htmMCd, htmSCd: idInfo.htmSCd, cmd: '' }));
  };

  return (
    <>
      <div className="displayFlexColumn" style={{ gap: '8px' }}>
        <Typography variant="subtitleBold">{t('step3.title')}</Typography>
        <Typography variant="body2Medium" style={{ whiteSpace: 'pre-wrap' }}>
          {t('step3.description')}
        </Typography>
      </div>
      {/*  */}
      <div className="displayFlexColumn" style={{ gap: '8px' }}>
        {/* <FindPasswordButton
          title={t('step3.email')}
          description={idInfo.htmInsaPerEmail}
          icon="arrow"
        /> */}
        <FindPasswordButton
          title={t('step3.sms')}
          description={formatPhoneNumber(idInfo.htmInsaPerHTel)}
          icon="arrow"
          onClick={clickSms}
        />
        <FindPasswordButton
          title={t('step3.alimtalk')}
          description={formatPhoneNumber(idInfo.htmInsaPerHTel)}
          icon="arrow"
          onClick={clickAlimtalk}
        />
      </div>
      <div className="displayFlexColumn" style={{ gap: '10px' }}>
        {/* <Button value={tCommon('confirm')} fullWidth onClick={() => stepHandler(3)} /> */}
        <Button color="sub" value={tCommon('cancel2')} fullWidth onClick={() => stepHandler(2)} />
      </div>
    </>
  );
};

export default Step3;
